// Ponte entre o evento de carrinho dos scripts conso e o do Horizon 4.
//
// PROBLEMA
// Os scripts conso (brinde progressivo, embalagem-presente, kits, upsell,
// oferta de quantidade) mexem no carrinho por conta própria e depois avisam o
// tema para re-renderizar a sacola. Na 3.x isso era:
//
//     document.dispatchEvent(new CustomEvent('cart:update', {
//       detail: { resource: cart, data: { sections, itemCount, source } }
//     }))
//
// e o `component-cart-items.js` lia `event.detail.data.sections`.
//
// A 4.x migrou para os Shopify Standard Events. O `cart:update` deixou de ser
// escutado por qualquer coisa — tanto o cart-items quanto o cart-drawer agora
// ouvem `shopify:cart:lines-update` — e o contrato mudou: as sections não vêm
// mais no detail do evento, e sim numa PROMISE anexada a ele, que resolve com
// `{ cart, detail: { sections, ... } }`.
//
// Resultado: os scripts conso disparavam no vazio. O item entrava no carrinho
// (o POST acontecia), mas a sacola só mostrava depois de um F5.
//
// SOLUÇÃO
// Em vez de reescrever os seis scripts, esta ponte escuta o evento legado e
// re-dispara no formato da 4.x. Fica num arquivo só e cobre qualquer script
// conso que venha a usar o mesmo padrão.
//
// Sobre abrir o drawer: a 4.x só auto-abre quando `event.action === 'add'`.
// Como toda atualização vinda daqui é de segundo plano, a ponte usa
// `action: 'update'` — o drawer re-renderiza e não abre sozinho. Isso torna a
// ponte independente da flag `__consoSilentCartUpdate`, que continua valendo
// para o `conso-cart-drawer-guard.js` (o guard cobre o caminho do showDialog).

(function () {
  var EVENTO_LEGADO = 'cart:update';
  var EVENTO_V4 = 'shopify:cart:lines-update';
  var MARCA = '__consoBridged';

  document.addEventListener(EVENTO_LEGADO, function (event) {
    // Evita reentrância caso algo re-emita o evento legado em cadeia.
    if (!event || event[MARCA]) return;
    event[MARCA] = true;

    var detail = event.detail || {};
    var data = detail.data || {};

    // As sections são o motivo de existir da ponte: sem elas não há o que
    // morphar, e o tema faria um refetch desnecessário.
    var sections = data.sections || detail.sections;
    if (!sections) return;

    var cart = detail.resource || detail.cart || data.cart || null;
    var itemCount = data.itemCount;
    if (typeof itemCount !== 'number' && cart && typeof cart.item_count === 'number') {
      itemCount = cart.item_count;
    }

    var ponte = new CustomEvent(EVENTO_V4, { bubbles: true });

    // O handler da 4.x lê estas duas propriedades direto do evento, não do
    // detail. 'update' (e não 'add') é o que impede o auto-open do drawer.
    ponte.action = 'update';
    ponte.promise = Promise.resolve({
      cart: cart,
      detail: {
        sections: sections,
        itemCount: itemCount,
        source: data.source || detail.sourceId || 'conso-cart-event-bridge',
      },
    });

    document.dispatchEvent(ponte);
  });
})();
